import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ReadingListDetails } from '®shared/reading-list';

@Component({
  selector: 'rl-lists-for-resource',
  templateUrl: './lists-for-resource.component.html',
})
export class ListsForResourceComponent {
  @Input() listsForResource: ReadingListDetails[];

  tenantCode: string;
  listRouteVersion: string;

  constructor(private route: ActivatedRoute) {
    const paramMap = this.route.snapshot.paramMap;
    this.listRouteVersion = `/${paramMap.get('version')}`;
    this.tenantCode = paramMap.get('tenantCode');
  }
}
